// home-bloco-validade — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "A data de fim da exibição é anterior à de início.": "La fecha de fin de la exhibición es anterior a la de inicio.",
    "Em branco, o bloco não tem prazo. Passada a data de fim, ele sai da Home sozinho — em aparelhos com o app desatualizado pode continuar aparecendo até a atualização.": "Si se deja vacío, el bloque no tiene plazo. Pasada la fecha de fin, sale solo de la pantalla de inicio — en dispositivos con la app desactualizada puede seguir apareciendo hasta que se actualice.",
};

export default catalogo;
